module.exports = ".feed-data{\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    background-color: white;\r\n    z-index: 1000;\r\n}\r\n\r\n.feed-data .dm-wrapper{\r\n    padding: 5px;\r\n}\r\n\r\n.feed-grid-wrapper {\r\n    margin: 5px;\r\n}\r\n\r\n/* Below are overrides to styles.css */\r\n\r\n.tools-header {\r\n    text-align: center;\r\n    background-color: #ffffff;\r\n    border-bottom: 0px;\r\n}\r\n\r\n\r\n\r\n   \r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/feeds/feed/feed.component.css
// module id = ./src/app/main/feeds/feed/feed.component.css
// module chunks = main